import React from 'react';
import { Alert, Button, Container, IconButton, Paper, Snackbar, Stack, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import { useAuthentication } from '../../../context/AuthContext';
import { get } from 'lodash';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import logo from '../../../assets/images/logo/logo.svg';
import { Link } from 'react-router-dom';
import { styled } from '@mui/system';

const StyledPaper = styled(Paper)(({ theme }) => ({
	maxWidth: '31.25rem',
	padding: '4rem 4rem 7rem',
	margin: 'auto',
	[theme.breakpoints.down('sm')]: {
		padding: '4rem 2rem 7rem',
	},
}));
function Login() {
	const { login } = useAuthentication();

	const [identifier, setIdentifier] = useState<string>('');
	const [password, setPassword] = useState<string>('');
	const [showPassword, setShowPassword] = useState<boolean>(false);
	const [errMsg, setErrMsg] = useState('');

	const handleLogin = async (event: React.FormEvent) => {
		event.preventDefault();
		if (identifier.trim() && password) {
			let res = await login(identifier.trim(), password);
			if (!get(res, 'status.OK')) {
				setErrMsg(get(res, 'errorMsg'));
			}
		} else {
			setErrMsg('E-Mail-Adresse oder Passwort darf nicht leer sein.');
		}
	};

	const handleKeyPress = (event: React.KeyboardEvent<HTMLFormElement>) => {
		if (event.key === 'Enter') {
			handleLogin(event);
		}
	};

	return (
		<>
			{errMsg && (
				<Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'right' }} open={Boolean(errMsg)} autoHideDuration={2000}>
					<Alert severity="error" onClose={() => setErrMsg('')}>
						{errMsg}
					</Alert>
				</Snackbar>
			)}
			<Container>
				<StyledPaper elevation={3}>
					<Typography sx={{ mb: '1rem', textAlign: 'center' }}>
						<img src={logo} alt="logo" />
					</Typography>

					<form onSubmit={handleLogin} onKeyDown={handleKeyPress}>
						<Stack alignItems={'center'} spacing={3}>
							<Typography variant="h6"> Anmeldung</Typography>

							<TextField
								fullWidth
								label="Benutzername"
								value={identifier}
								onChange={(e) => setIdentifier(e.target.value)}
							/>

							<TextField
								fullWidth
								label="Passwort"
								type={showPassword ? 'text' : 'password'}
								value={password}
								onChange={(e) => setPassword(e.target.value)}
								InputProps={{
									endAdornment: (
										<IconButton aria-label="toggle password visibilty" onClick={() => setShowPassword(!showPassword)}>
											{showPassword ? <Visibility /> : <VisibilityOff />}
										</IconButton>
									),
								}}
							/>
							<Button variant="loginButton" size="large" type="submit">
								Login
							</Button>
							<Stack
								direction={{ xs: 'column', sm: 'row' }}
								spacing={2}
								justifyContent={'center'}
								alignItems={'center'}
								sx={{ width: '100%' }}
							>
								<Link to="/registrierung"> Registrieren </Link>
								<Link to="/passwort-vergessen">Passwort vergessen?</Link>
							</Stack>
						</Stack>
					</form>
				</StyledPaper>
			</Container>
		</>
	);
}

export default Login;
